import { styled, Typography } from "@mui/material";

export const LessonContainer = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,

  [theme.breakpoints.down("tablet")]: {
    color: theme.palette.custom.grey.main,
  },
}));
